import { render, staticRenderFns } from "./PartnerImports.vue?vue&type=template&id=92efa3c6&"
import script from "./PartnerImports.vue?vue&type=script&lang=js&"
export * from "./PartnerImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports